@if (visible()) {
  <ds-box elevation="component">
    <ds-box-content spacing="sm">
      <ds-list-item [isGroupTitle]="true">{{ 'case.recentSearches' | translate }}</ds-list-item>
      @for (recentSearchString of recentSearchStrings(); track recentSearchString) {
        <ds-list-item [isHoverable]="true"
                      (mousedown)="$event.preventDefault()"
                      (click)="selectSuggestion(recentSearchString)"
                      (keydown.enter)="selectSuggestion(recentSearchString)"
                      (keydown.space)="$event.preventDefault(); selectSuggestion(recentSearchString)">
          {{ recentSearchString }}
        </ds-list-item>
      }
    </ds-box-content>
  </ds-box>
}
